export const app = {
  'App Vialaser': 'App Vialaser',
  'The Vialaser app in the palm of your hand': 'A Vialaser na palma da sua mão',
  'Download the app and have full control of your laser hair removal treatments — wherever you are.':
    'Baixe o app e tenha controle total dos seus tratamentos de depilação a laser — onde estiver.',
  'We are a network of clinics focused on laser hair removal. We created the app to give you more autonomy and convenience to handle everything from your phone, without needing to call or visit a clinic.':
    'Somos uma rede de clínicas focada em depilação a laser. Criamos o app pensando em dar mais autonomia e praticidade para você resolver tudo pelo celular, sem precisar ligar ou ir até a unidade.',
  'Everything you need, in your pocket':
    'Tudo o que você precisa, no seu bolso',
  'Session scheduling': 'Agendamento de sessão',
  'Book, reschedule or cancel your session in a few taps.':
    'Marque, remarque ou cancele sua sessão em poucos toques.',
  'Online store': 'Loja online',
  'Buy packages and products directly through the app.':
    'Compre pacotes e produtos direto pelo app.',
  'Financial control': 'Controle financeiro',
  'Keep track of payments and installments of your treatments.':
    'Acompanhe pagamentos e parcelas dos seus tratamentos.',
  'Session reminders': 'Lembrete de sessão',
  'Get notified so you never miss your session.':
    'Receba notificações para nunca perder sua sessão.',
  'Convenience that fits in your pocket': 'Praticidade que cabe no seu bolso',
  'Everything you need to manage your treatments is one tap away.':
    'Tudo o que você precisa para cuidar dos seus tratamentos está a um toque de distância.',
  'Vialaser app home screen preview':
    'Pré-visualização da tela inicial do app Vialaser',
};
